<template>
  <ul v-if="!isLoggedIn"
      class="bx-header__user-navi">
    <li>
      <a href="/registrieren"
         class="bx-typo--link">
        Registrieren
      </a>
    </li>
    <li>
      <a href="/anmelden"
         class="bx-typo--link">
        Anmelden
      </a>
    </li>
  </ul>
  <ul v-else
      class="bx-header__user-navi">
    <li>
      <a href="/mein-abo"
         class="bx-typo--link">
        Mein Abo
      </a>
    </li>
    <li>
      <a class="bx-typo--link"
         href="#"
         @click="doLogout">
        Abmelden
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'pinia'

import { useSessionStore } from '../../../stores/session'

export default {
  computed: {
    ...mapState(useSessionStore, ['isLoggedIn'])
  },
  methods: {
    ...mapActions(useSessionStore, ['logout']),
    doLogout () {
      this.logout()
      window.location.href = '/?notify=logout-success'
    }
  }
}
</script>
